import { ManageCommon } from "./base-manager.abstract";

export abstract class ComScoreManage extends ManageCommon {
  protected comscoreLibId = "comscore-lib";
}
